export default {
  arrProvinces:[],
  searchData: {
    province: "",
    city: "",
    appShortName: "",
    appCode: ""
  },
  arrUnitTypes: [],
  pageData: {
    page: 1,
    total: 0,
    size: 20
  },
  activeTabId: "1",
  tableData: [{}],
  createData: {
    id: "",
    province: "",
    city: "",
    appName: "",
    appShortName: ""
  },
  // 详情
  showDetailDrawer: false,
  detailCurrentTabId: 1,
  detailAppId: "",
  appDetail: {

  },
  appStatistics: {
    amUseCount: 0,
    amUseCountUp: 0,
    dmCreateCount: 0,
    dmCreateCountUp: 0,
    dmVisitRelationCount: 0,
    dmVisitRelationCountUp: 0
  },
  detailPageData: {
    page: 1,
    total: 0,
    size: 20
  },
  // 告别厅列表
  hallTableData: [],
  // 告别会列表
  ceremoryTableData: [],
  // 运营帐号
  accountTableData: [],
  // 模板列表
  templateTableData: []
}



// WEBPACK FOOTER //
// ./src/store/modules/Unit/state.js